exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal_modal-content_fN1pD {\n  background-color: white;\n  color: #575e75;\n}\n[theme=\"dark\"] .modal_modal-content_fN1pD {\n  background-color: var(--ui-primary);\n  color: var(--text-primary);\n}\n", ""]);

// exports
exports.locals = {
	"modal-content": "modal_modal-content_fN1pD",
	"modalContent": "modal_modal-content_fN1pD"
};